import { motion } from 'framer-motion'

const items = [
  {
    label: 'Demand Sensing',
    title: '4 SKUs flagged for 9/1 OR schedule',
    description: 'Trocars, Retractor, Clip Applier below threshold',
    cta: 'Review order',
    height: 80,
  },
  {
    label: 'PAR Review',
    title: '2 par-level recommendations',
    description: 'Adjusted based on August surgical volume projection',
    cta: 'View report',
    height: 97,
  },
  {
    label: 'Schedule Confirmation',
    title: 'Awaiting Tuesday case count confirmation',
    description: 'Agent sent request at 6:00 AM to OR coordinator',
    cta: 'View request',
    height: 80,
  },
]

export default function NeedsAttentionPanel({ detailOpen, onDemandSensingClick }) {
  return (
    <div style={{
      width: '100%',
      padding: 16,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      flexShrink: 0,
    }}>
      {/* Header */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.4 }}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 28,
          flexShrink: 0,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={labelStyle}>Needs Attention</span>
          <motion.span
            animate={{ opacity: [1, 0.55, 1] }}
            transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut', delay: 2 }}
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: '#F8F8F7',
              background: 'rgba(235,23,0,0.35)',
              borderRadius: 3,
              padding: '1px 6px',
            }}
          >
            3
          </motion.span>
        </div>
        <ChevronBtn />
      </motion.div>

      {/* Cards */}
      {items.map((item, i) => {
        const isSelected = i === 0 && detailOpen
        const isClickable = i === 0
        return (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1], delay: 0.65 + i * 0.1 }}
          whileHover={{ y: -2, transition: { duration: 0.18 } }}
          onClick={isClickable ? onDemandSensingClick : undefined}
          style={{
            background: 'rgba(0,0,0,0.3)',
            borderRadius: 4,
            padding: '10px 12px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            boxShadow: isSelected
              ? '0 0 0 1px rgba(255,255,255,0.35), 0 4px 44px rgba(0,0,0,0.1)'
              : '0 4px 44px rgba(0,0,0,0.1)',
            flexShrink: 0,
            cursor: isClickable ? 'pointer' : 'default',
          }}
        >
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <span style={labelStyle}>{item.label}</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#FFFFFF', lineHeight: 1.4 }}>
              {item.title}
            </span>
            <span style={{ fontSize: 12, fontWeight: 400, color: '#D5CFC9', lineHeight: 1.4 }}>
              {item.description}
            </span>
          </div>
          <motion.button
            whileHover={{ scale: 1.05, filter: 'brightness(1.15)' }}
            whileTap={{ scale: 0.96 }}
            style={{
              background: '#EB1700',
              border: 'none',
              borderRadius: 8,
              padding: '4px 10px',
              height: 26,
              fontSize: 12,
              fontWeight: 500,
              color: '#FFFFFF',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              marginLeft: 10,
              flexShrink: 0,
              fontFamily: 'inherit',
            }}
          >
            {item.cta}
          </motion.button>
        </motion.div>
        )
      })}
    </div>
  )
}

const chevronBtnVariants = { rest: { scale: 1 }, hover: { scale: 1.15 } }
const chevronIconVariants = { rest: { rotate: 0 }, hover: { rotate: 180 } }

function ChevronBtn() {
  return (
    <motion.button
      variants={chevronBtnVariants} initial="rest" whileHover="hover"
      transition={{ duration: 0.25 }}
      style={{ width: 28, height: 28, borderRadius: 8, background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <motion.svg variants={chevronIconVariants} transition={{ duration: 0.25 }} width="10" height="6" viewBox="0 0 10 6" fill="none">
        <path d="M1 1L5 5L9 1" stroke="#A39992" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </motion.svg>
    </motion.button>
  )
}

const labelStyle = {
  fontSize: 10,
  fontWeight: 700,
  color: '#A39992',
  textTransform: 'uppercase',
  letterSpacing: '0.09em',
}
